import { Routes } from '@angular/router';
import { InvoicesComponent } from './invoices.component';

import { InvoiceComponent } from './invoice/invoice.component';

export const InvoicesRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "invoices",
        component: InvoicesComponent,
      },
      {
        path: "invoices/:id",
        component: InvoiceComponent,
      },
    ],
  },
];